import { lazy } from 'react';

const Home = lazy(() => import('./home'));
const Summary = lazy(() => import('./summary'));
const Payments = lazy(() => import('./payments'));
const BackOffice = lazy(() => import('./back-office'));
const Transactions = lazy(() => import('./transactions'));

export { Home, Summary, Payments, BackOffice, Transactions };
